module.exports = __webpack_public_path__ + "media/images/icons/mandk_icon-df8451535bbbc8669fa052e2ae606264.svg";